import $ from 'jquery';
import 'jquery-mousewheel';
import Prefixed from '../../modules/prefixed/prefixed';

export default class {
	constructor(options) {
		const defaults = {
			el: '#layoutDefault',
			dom: {
				screen: '.js-layout-screen',
				scroll: '.js-layout-scroll',
				inner: '.js-layout-inner',
				start: '.js-layout-start',
				next: '.js-layout-screen-next',

				statue: '.js-layout-statue',
				scene: '.js-layout-scene'
			},
			classes: {
				active: 'layout__screen_state_active',
				scene1: 'layout_scene_1',
				scene2: 'layout_scene_2',
				scene3: 'layout_scene_3',
				scene4: 'layout_scene_4',
				popup: 'layout_state_popup',
				final: 'layout_state_final'
			}
		};
		this.options = $.extend(true, {}, defaults, options);
		this.$window = $(window);
		this.$document = $(document);
		this.$el = $(this.options.el);
		this.lock = true;
		this.delta = 0;
		this.touch = 0;
		this.index = 0;
		this.prefixed = new Prefixed();
		return this;
	}

	getDom() {
		this.$screen = this.$el.find(this.options.dom.screen);
		this.$scroll = this.$el.find(this.options.dom.scroll);
		this.$inner = this.$el.find(this.options.dom.inner);
		this.$start = this.$el.find(this.options.dom.start);
		this.$next = this.$el.find(this.options.dom.next);

		this.$statue = this.$el.find(this.options.dom.statue);
		this.$scene = this.$el.find(this.options.dom.scene);
		return this;
	}

	onUnlock(fast = false) {
		const self = this;
		if (fast) {
			self.lock = false;
		}else {
			setTimeout(function () {
				self.lock = false;
			}, 1000);
		}
		return self;
	}

	onLock() {
		this.lock = true;
		return this;
	}

	check(index = false, scrolled = 0) {
		if (!this.lock) {
			const $current = this.$screen.filter('.' + this.options.classes.active);

			let $activate = false;

			if (index !== false) {
				$activate = this.$screen.eq(index);
			}

			const $scroll = $current.find(this.$scroll);
			const $inner = $current.find(this.$inner);

			if (scrolled === true && $scroll.scrollTop() + $scroll.height() < $inner.height() - 2) {
				scrolled = 0;
				this.onLock();
				const self = this;
				setTimeout(function () {
					self.onUnlock(true);
				}, 250);
			}

			if (scrolled === false && $scroll.scrollTop() > 2) {
				scrolled = 0;
				this.onLock();
				const self = this;
				setTimeout(function () {
					self.onUnlock(true);
				}, 250);
			}


			if (scrolled !== 0 && scrolled === true) {
				$activate = $current.next();
			}

			if (scrolled !== 0 && scrolled === false) {
				$activate = $current.prev();
			}


			if ($activate !== false && $activate.length && $activate.is(this.$screen)) {
				this.onLock();
				if (index === false) {
					this.index = $activate.index() - 1;
				}else {
					this.index = index;
				}
				$activate.addClass(this.options.classes.active);
				$current.removeClass(this.options.classes.active);

				this.$el
					.removeClass(this.options.classes.scene1)
					.removeClass(this.options.classes.scene2)
					.removeClass(this.options.classes.scene3)
					.removeClass(this.options.classes.scene4);

				this.$el.addClass(this.options.classes[$activate.data('type')]);

				this.onUnlock();
			}
		}
	}

	onNext(event) {
		event.preventDefault();
		if (this.isMobile()){
			this.$scene.animate({scrollTop: this.$screen.first().height()}, '300', 'swing');
		}else {
			this.check(this.index + 1);
		}
	}

	isMobile() {
		return this.$el.width() < 768;
	}

	setScreen(event, index) {
		this.check(index);
	}

	onScreen(event) {
		const $target = $(event.currentTarget);
		const target = $target.data('screen');
		if (this.max >= target && target !== this.index) {
			this.check($target.data('screen'));
		}
	}

	onWheel(e) {
		const $target = $(e.target);
		const event = e || window.event;
		const delta = event.detail || event.wheelDelta || -event.deltaY;
		if (!this.lock && !$target.closest('.js-scroll').length && !this.isMobile()) {
			if ((this.delta < 0 && delta > 0) || (this.delta > 0 && delta < 0)) {
				this.delta = 0;
			}
			this.delta += delta;
			let set = 0;
			if (this.delta < -20) {
				set = 1;
			}

			if (this.delta > 20) {
				set = -1;
			}
			if (set !== 0) {
				this.delta = 0;
				this.check(false, set > 0);
			}
		}
	}

	onKey(event) {
		const code = event.keyCode || event.which;
		if (!this.lock && !this.isMobile()) {
			let set = 0;
			if ((code === 34 || code === 40)) {
				set = 1;
			}

			if ((code === 33 || code === 38)) {
				set = -1;
			}
			if (set !== 0) {
				this.check(false, set > 0);
			}
		}
	}

	onTouchStart(event) {
		const $target = $(event.target);
		if (!this.lock && !$target.closest('.js-scroll').length && !this.isMobile()) {
			this.touch = event.pageY || event.originalEvent.changedTouches[0].pageY;
		}
	}

	onTouchEnd(event) {
		const end = event.pageY || event.originalEvent.changedTouches[0].pageY;
		const delta = this.touch - end;
		if (!this.lock && this.touch !== false) {
			this.delta += delta;

			let set = 0;
			if (delta > 40) {
				set = 1;
			}

			if (delta < -40) {
				set = -1;
			}
			if (set !== 0) {
				this.check(false, set > 0);
				this.touch = false;
			}
		}
		if (event.type === 'touchend') {
			this.touch = false;
		}
	}

	onPopupOpen() {
		this.scrollFix(true);
		this.onLock();
		this.$el.addClass(this.options.classes.popup);
		setTimeout(() => {
		    alert('Сайт работает в демо режиме, поэтому вы заполнили все поля за вас.');
        }, 150);
	}

	onPopupClose() {
		this.onUnlock();
		this.$el.removeClass(this.options.classes.popup);
		this.scrollFix(false);
	}

	onFinal() {
		this.scrollFix(true);
		this.onLock();
		this.$el
			.removeClass(this.options.classes.popup)
			.addClass(this.options.classes.final);
	}

	onScene() {
		if (this.isMobile()) {
			// const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
			// console.log(scrollTop);

			// let sh = 0;
			// this.$screen.each(function () {
			// 	sh += $(this).height();
			// });
			// const height = sh - this.$screen.last().height();
			// const heightStatue = this.$statue.height();

			// const top = scrollTop * 0.7;
			// this.$statue.css(this.prefixed.css.transform, 'translateY(' + top + 'px) translateZ(0)');
		}
	}

	scrollFix(open = false) {
		if (open) {
			this.scrollTop = window.pageYOffset;
			this.$window.scrollTop(0);
		}else {
			this.$window.scrollTop(this.scrollTop);
		}
	}

	render() {
		if (this.$el.length) {
			this.getDom();

			if (this.$document[0].addEventListener) {
				if ('onwheel' in document) {
					this.$document[0].addEventListener('wheel', this.onWheel.bind(this));
				}else if ('onmousewheel' in document) {
					this.$document[0].addEventListener('mousewheel', this.onWheel.bind(this));
				}else {
					this.$document[0].addEventListener('MozMousePixelScroll', this.onWheel.bind(this));
				}
			}else {
				this.$document[0].attachEvent('onmousewheel', this.onWheel.bind(this));
			}

			this.$document
				.on('touchstart', this.onTouchStart.bind(this))
				.on('touchmove', this.onTouchEnd.bind(this))
				.on('touchend', this.onTouchEnd.bind(this))
				.on('keydown', this.onKey.bind(this));

			this.$next.on('click', this.onNext.bind(this));
			this.$start.on('click', this.onPopupOpen.bind(this));

			this.$window.on('popup.open', this.onPopupOpen.bind(this));
			this.$window.on('popup.close', this.onPopupClose.bind(this));
			this.$window.on('screen.final', this.onFinal.bind(this));

			// const self = this;
			// setInterval(function () {
			// 	self.onScene();
			// }, 13);
			// this.$window.on('scroll resize', this.onScene.bind(this));

			if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i)) {
				$('html').addClass('isiphone');
			}

			this.onUnlock();
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/layouts/default/default.js